import axios from "@/api/axiosInstance";
import { FetchCampaignIterationsStatusResponse } from "./types";

export const fetchCampaignIterationsStatus = async (
  campaignId: number,
): Promise<FetchCampaignIterationsStatusResponse> => {
  const response = await axios.get<FetchCampaignIterationsStatusResponse>(
    `/api/private/stochastic/${campaignId}/campaign-iterations-status-data`,
  );

  return response.data;
};
